var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.item.title))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('em',{staticClass:"fas fa-chevron-right"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-898123cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/ticket3/ticket-management/WrapUpInput/WrapUpParent.vue
// module id = null
// module chunks = 